// extracted by mini-css-extract-plugin
module.exports = {"ExpandingTextarea":"ExpandingTextarea_ExpandingTextarea__2mYgK","growWrap":"ExpandingTextarea_growWrap__1qRHa"};